"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.auditlog = void 0;
const endpoint_1 = require("api/endpoint");
const permissions_1 = require("shared/permissions");
exports.auditlog = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY,
    method: "post",
    path: "audit-logger/auditlog",
});



//////////////////
// WEBPACK FOOTER
// ./src/api/audit-logger/audit-logger-client.ts
// module id = 980
// module chunks = 0 1 2